import React from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import configData from "./config.json";
import Cookies from 'js-cookie';
var CryptoJS = require("crypto-js");

function Login() {
  const [username, setUsername] = useState('');
  const [usernameError, setUsernameError] = useState('');
  const [password, setPassword] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loginStart, setLoginStart] = useState(false);
  const [apiErrorMessage, setApiErrorMessage] = useState('');
  const [navigateSuccessMessage, setNavigateSuccessMessage] = useState('');
  // eslint-disable-next-line
  const navigate = useNavigate();
  const isEmail = (email) => /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);
  const doUserLogIn = async function () {
    setUsernameError('');
    setPasswordError('');
    setApiErrorMessage('');
    setNavigateSuccessMessage('');
    if (username !== '') {
      if (!isEmail(username)) {
        setUsernameError('Invalid Email');
      } else {
        if(password !== '') {
          setLoginStart(true);
          const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email: username, password: password })
          };
          try {
            fetch(configData.SERVER_URL+"/loginWithPassword", requestOptions)
              .then(response => {
                return response.json()
              })
              .then(results => {
                if (results.success === true) {
                  if (results.data.status === true) {
                    Cookies.set('user', CryptoJS.AES.encrypt(JSON.stringify({"user_type": results.data.user.type,"name": results.data.user.name,"email": results.data.user.email,"company": results.data.user.company,"google_id": results.data.user.google,"aniview_id": results.data.user.aniview,"adkernel_id": results.data.user.adkernel}), 'XJ3ou%#1').toString(), { expires: 7 });
                    Cookies.remove('registration_msg');
                    Cookies.set('status', true, { expires: 7 });
                    navigate("/dashboard");
                  } else {
                    setApiErrorMessage(results.message);
                  }
                } else {
                  setApiErrorMessage(results.message);
                }
                setLoginStart(false);
              }).catch(error=>{
                alert("There is some error in processing your request. Please try again in some time.");
              })
            return true;
          } catch (error) {
            setApiErrorMessage('Something went wrong. Please Try Again.');
            return false;
          }
        }else {
          setPasswordError('This field is required.');
        }
      }
       
    } else {
      setUsernameError('This field is required.');
    }
  };

  const keyDownHandler = event => {
    setUsernameError('');
    setPasswordError('');
    if (event.key === 'Enter') {
      event.preventDefault();
      doUserLogIn();
    }
  }

  const handleVisiblePass = () => {
    setShowPassword(!showPassword);
  }

  const signinOtp = () => {
    setUsernameError('');
    setPasswordError('');
    setApiErrorMessage('');
    if (username !== '') {
      if (!isEmail(username)) {
        setUsernameError('Invalid Email');
      } else {
        setLoginStart(true);
        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email: username })
        };
        try {
          fetch(configData.SERVER_URL+"/login", requestOptions)
            .then(response => {
              return response.json()
            })
            .then(results => {
              if (results.success === true) {
                if (results.data.status === true) {
                  Cookies.set('emailAuthenticated', results.success, { expires: 7 });
                  Cookies.set('user', CryptoJS.AES.encrypt(JSON.stringify({"user_type": results.data.user.type,"name": results.data.user.name,"email": results.data.user.email,"company": results.data.user.company,"google_id": results.data.user.google,"aniview_id": results.data.user.aniview,"adkernel_id": results.data.user.adkernel}), 'XJ3ou%#1').toString(), { expires: 7 });
                  Cookies.remove('registration_msg');
                  navigate("/otp");
                } else {
                  setApiErrorMessage(results.message);
                }
              } else {
                setApiErrorMessage(results.message);
              }
              setLoginStart(false);
            }).catch(error=>{
              alert("There is some error in processing your request. Please try again in some time.");
            })
          return true;
        } catch (error) {
          setApiErrorMessage('Something went wrong. Please Try Again.');
          return false;
        }
      }
       
    } else {
      setUsernameError('This field is required.');
    }
  }

  useEffect(() => {
    const flashEmail = sessionStorage.getItem("flashEmail");
    if (flashEmail) {
      setUsername(flashEmail);
      // Clear the message from sessionStorage after it has been displayed
      sessionStorage.removeItem("flashEmail");
    }

    const message = sessionStorage.getItem("successMessage");
    if (message) {
      setNavigateSuccessMessage(message);
      // Clear the message from sessionStorage after it has been displayed
      sessionStorage.removeItem("successMessage");
    }
  }, []);

  const goToForgotPassword = () => {
    sessionStorage.setItem("flashEmail", username);
    navigate("/forgot-password");
  }

  if (!Cookies.get('status')) {
    return (

      <div className="d-flex bg_main justify-content-between">
        <div className="login_content">
          <div className="login_text">
            <h2 className="login_heading">Harnessing Data to Drive Smarter Advertising Decisions.</h2>
            <p>Elevate Your Website's Ad Placement Strategy with<br /> Advanced Analytics.</p>
          </div>
          <div className="login_img">
            <img src="assets/media/images/login_img.svg" alt="login" />
          </div>
        </div>

        <div className="login_form d-flex align-items-center justify-content-center">
          <div className="login_form_inner">

            {Cookies.get('registration_msg') === 'TRUE' && (
              <div className="success_message" style={{ opacity: 1 }}>
                <div className="d-flex align-items-center">
                  <div className="icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                      <path d="M13.9999 2.33325L17.0641 4.56859L20.8575 4.56159L22.0225 8.17125L25.0955 10.3949L23.9165 13.9999L25.0955 17.6049L22.0225 19.8286L20.8575 23.4383L17.0641 23.4313L13.9999 25.6666L10.9356 23.4313L7.14221 23.4383L5.9773 19.8286L2.9043 17.6049L4.08321 13.9999L2.9043 10.3949L5.9773 8.17125L7.14221 4.56159L10.9356 4.56859L13.9999 2.33325Z" stroke="#008500" strokeWidth="2.33333" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M9.91675 13.9999L12.8334 16.9166L18.6667 11.0833" stroke="#008500" strokeWidth="2.33333" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </div>
                  <div className="text">
                    <h5 className="succcess_heading">Thank You</h5>
                    <p>Congratulations, your account has been successfully created.</p>
                  </div>
                </div>
              </div>
            )}

            {navigateSuccessMessage && <div className="success_message">
              <div className="d-flex align-items-center">
                <div className="icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                    <path d="M13.9999 2.33325L17.0641 4.56859L20.8575 4.56159L22.0225 8.17125L25.0955 10.3949L23.9165 13.9999L25.0955 17.6049L22.0225 19.8286L20.8575 23.4383L17.0641 23.4313L13.9999 25.6666L10.9356 23.4313L7.14221 23.4383L5.9773 19.8286L2.9043 17.6049L4.08321 13.9999L2.9043 10.3949L5.9773 8.17125L7.14221 4.56159L10.9356 4.56859L13.9999 2.33325Z" stroke="#008500" strokeWidth="2.33333" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M9.91675 13.9999L12.8334 16.9166L18.6667 11.0833" stroke="#008500" strokeWidth="2.33333" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
                <div className="text">
                  <h5 className="succcess_heading">{navigateSuccessMessage}</h5>
                </div>
              </div>
            </div>}

            {apiErrorMessage && <div className="error_message">
              <div className="d-flex align-items-center">
                <div className="icon">
                <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" clipRule="evenodd" d="M5.61636 23.8429H22.3965C24.2422 23.8429 25.4007 21.8479 24.4837 20.2449L16.1 5.58571C15.1772 3.97221 12.8509 3.97104 11.9269 5.58454L3.52919 20.2437C2.61219 21.8467 3.76953 23.8429 5.61636 23.8429Z" stroke="#ED0017" strokeWidth="2.33" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M14.003 15.6506V12.0339" stroke="#ED0017" strokeWidth="2.33" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M13.9942 19.2498H14.0059" stroke="#ED0017" strokeWidth="2.33" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                </div>
                <div className="text">
                  <h5 className="succcess_heading">{apiErrorMessage}</h5>
                </div>
              </div>
            </div>}

            <div className="form_group">
              <h1 className="heading mb_55px">Welcome!</h1>
            </div>
            <div className="form_group mb_5px">
              <label htmlFor="exampleFormControlInput1" className="form-label">Email Address</label>
              <div className={(username) ? 'input-group flex-nowrap w-100 active' : 'input-group flex-nowrap w-100'}>
                <span className="input-group-text" id="addon-wrapping">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" className="fill">
                    <path d="M10 17C9.04333 17 8.13917 16.8161 7.2875 16.4484C6.43583 16.0807 5.69197 15.579 5.0559 14.9434C4.4203 14.3078 3.91863 13.5642 3.5509 12.7125C3.18317 11.8608 2.99953 10.9567 3 10C3 9.03167 3.18387 8.12447 3.5516 7.2784C3.91933 6.43233 4.421 5.69173 5.0566 5.0566C5.6922 4.42053 6.4356 3.91887 7.2868 3.5516C8.138 3.18433 9.0424 3.00047 10 3C10.9683 3 11.8755 3.18387 12.7216 3.5516C13.5677 3.91933 14.3083 4.421 14.9434 5.0566C15.5795 5.6922 16.0811 6.43303 16.4484 7.2791C16.8157 8.12517 16.9995 9.03213 17 10V11.015C17 11.7033 16.7639 12.2897 16.2916 12.7741C15.8193 13.2585 15.2388 13.5005 14.55 13.5C14.13 13.5 13.7392 13.4067 13.3775 13.22C13.0158 13.0333 12.7183 12.7883 12.485 12.485C12.17 12.8 11.7995 13.048 11.3734 13.2291C10.9473 13.4102 10.4895 13.5005 10 13.5C9.03167 13.5 8.20613 13.1586 7.5234 12.4759C6.84067 11.7932 6.49953 10.9679 6.5 10C6.5 9.03167 6.84137 8.20613 7.5241 7.5234C8.20683 6.84067 9.03213 6.49953 10 6.5C10.9683 6.5 11.7939 6.84137 12.4766 7.5241C13.1593 8.20683 13.5005 9.03213 13.5 10V11.015C13.5 11.3533 13.605 11.6186 13.815 11.8109C14.025 12.0032 14.27 12.0995 14.55 12.1C14.83 12.1 15.075 12.0036 15.285 11.8109C15.495 11.6182 15.6 11.3529 15.6 11.015V10C15.6 8.47167 15.0486 7.15613 13.9459 6.0534C12.8432 4.95067 11.5279 4.39953 10 4.4C8.47167 4.4 7.15613 4.95137 6.0534 6.0541C4.95067 7.15683 4.39953 8.47213 4.4 10C4.4 11.5283 4.95137 12.8439 6.0541 13.9466C7.15683 15.0493 8.47213 15.6005 10 15.6H12.8C12.9983 15.6 13.1647 15.6672 13.2991 15.8016C13.4335 15.936 13.5005 16.1021 13.5 16.3C13.5 16.4983 13.4328 16.6647 13.2984 16.7991C13.164 16.9335 12.9979 17.0005 12.8 17H10ZM10 12.1C10.5833 12.1 11.0792 11.8958 11.4875 11.4875C11.8958 11.0792 12.1 10.5833 12.1 10C12.1 9.41667 11.8958 8.92083 11.4875 8.5125C11.0792 8.10417 10.5833 7.9 10 7.9C9.41667 7.9 8.92083 8.10417 8.5125 8.5125C8.10417 8.92083 7.9 9.41667 7.9 10C7.9 10.5833 8.10417 11.0792 8.5125 11.4875C8.92083 11.8958 9.41667 12.1 10 12.1Z" />
                  </svg>
                </span>
                <input type="email" className="form_control" placeholder="example@gmail.com" aria-label="UserID" aria-describedby="addon-wrapping" value={username} onChange={(event) => setUsername(event.target.value)} onKeyDown={keyDownHandler} />
              </div>
              <span className="error mb-2">{usernameError}</span>
            </div>
            
            <div className="form_group mb_5px">
              <label htmlFor="exampleFormControlInput2" className="form-label">Password</label>
              <div className="view_pass">
                <div className={(password) ? 'input-group flex-nowrap w-100 active' : 'input-group flex-nowrap w-100'}>
                  <span className="input-group-text" id="addon-wrapping">
                    
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" className="stroke" xmlns="http://www.w3.org/2000/svg">
                      <path d="M13.6868 7.87321V6.08404C13.6868 3.98987 11.9884 2.29154 9.89427 2.29154C7.8001 2.28237 6.0951 3.97237 6.08594 6.06737V6.08404V7.87321" stroke="#CFD3D4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      <path fillRule="evenodd" clipRule="evenodd" d="M13.0695 17.7081H6.70199C4.95699 17.7081 3.54199 16.294 3.54199 14.5481V10.974C3.54199 9.22813 4.95699 7.81396 6.70199 7.81396H13.0695C14.8145 7.81396 16.2295 9.22813 16.2295 10.974V14.5481C16.2295 16.294 14.8145 17.7081 13.0695 17.7081Z" stroke="#CFD3D4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M9.88639 11.8357V13.6865" stroke="#CFD3D4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>

                  </span>
                  <input type={(showPassword)?'text':'password'} className="form_control password" placeholder="Enter password" aria-label="UserPassword" aria-describedby="addon-wrapping" value={password} onChange={(event) => setPassword(event.target.value)} onKeyDown={keyDownHandler} />
                </div>
                <button className="btn_view">
                <span className="hidePass" onClick={handleVisiblePass}>
                  {
                    (showPassword)
                    ?
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fillRule="evenodd" clipRule="evenodd" d="M12.6354 10.0442C12.6354 11.4992 11.4554 12.6783 10.0004 12.6783C8.54538 12.6783 7.36621 11.4992 7.36621 10.0442C7.36621 8.58835 8.54538 7.40918 10.0004 7.40918C11.4554 7.40918 12.6354 8.58835 12.6354 10.0442Z" stroke="#9E9E9E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      <path fillRule="evenodd" clipRule="evenodd" d="M9.99866 16.129C13.172 16.129 16.0745 13.8473 17.7087 10.044C16.0745 6.24065 13.172 3.95898 9.99866 3.95898H10.002C6.82866 3.95898 3.92616 6.24065 2.29199 10.044C3.92616 13.8473 6.82866 16.129 10.002 16.129H9.99866Z" stroke="#9E9E9E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    :
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8.13314 11.9722C7.65397 11.4938 7.3623 10.8438 7.3623 10.1147C7.3623 8.65382 8.53897 7.47632 9.99897 7.47632C10.7215 7.47632 11.3865 7.76882 11.8573 8.24715" stroke="#9E9E9E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M12.5868 10.5823C12.3935 11.6573 11.5468 12.5056 10.4727 12.7006" stroke="#9E9E9E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M5.54518 14.5602C4.22268 13.5219 3.10268 12.0052 2.29102 10.1144C3.11102 8.21523 4.23852 6.69023 5.56935 5.64356C6.89185 4.5969 8.41768 4.02856 9.99935 4.02856C11.5902 4.02856 13.1152 4.60523 14.446 5.6594" stroke="#9E9E9E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M16.2063 7.49219C16.7796 8.25385 17.2838 9.13302 17.708 10.1139C16.0688 13.9114 13.1721 16.1989 9.99965 16.1989C9.28048 16.1989 8.57132 16.0822 7.88965 15.8547" stroke="#9E9E9E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M16.5718 3.54126L3.42676 16.6863" stroke="#9E9E9E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                  }
                </span>
                </button>
              </div>
              <span className="error mb-2">{passwordError}</span>
            </div>
            <div className="form_group mb_36px">
              <button className="loginModeBtn otpBtn" type="button" onClick={signinOtp}>Sign In using OTP</button>
              <button className="loginModeBtn forgotBtn" type="button" onClick={goToForgotPassword}>Forgot Password?</button>
            </div>

            <div className="form_group mb-0">
              <button type="button" className={(loginStart) ? 'btn_primary loading_btn' : 'btn_primary'} onClick={() => doUserLogIn()}>
                {
                  (loginStart)
                    ?
                    <>
                      <span className="loader_text hide">SIGNING IN <i className="fa fa-spinner fa-spin ms-1"></i></span>
                    </>
                    :
                    <>
                      <span className="btn_text">SIGN IN</span>
                    </>
                }
              </button>
            </div>
          </div>
        </div>
      </div >
    );
  } else {
    window.location.href = "/dashboard";
  }
}

export default Login;